/* tslint:disable */
/* eslint-disable */
/* @relayHash d1483f6b69aca786f9097d2e6d45f079 */

import { ConcreteRequest } from "relay-runtime";
export type PostSignupPublishSheetPageQueryVariables = {};
export type PostSignupPublishSheetPageQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly id: string;
        } | null;
    } | null;
};
export type PostSignupPublishSheetPageQuery = {
    readonly response: PostSignupPublishSheetPageQueryResponse;
    readonly variables: PostSignupPublishSheetPageQueryVariables;
};



/*
query PostSignupPublishSheetPageQuery {
  viewer {
    user {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Viewer",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PostSignupPublishSheetPageQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PostSignupPublishSheetPageQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "PostSignupPublishSheetPageQuery",
    "id": null,
    "text": "query PostSignupPublishSheetPageQuery {\n  viewer {\n    user {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '9e9ea575199146ee3829f433a26f950c';
export default node;
